declare namespace $ {

	type __shm_hitalama_map_settings_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_settings['slideshow_enabled'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_settings['map'] >['slideshow_enabled'] >[0]
	>
	type __shm_hitalama_map_settings_2 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_settings['camera_locked'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_settings['map'] >['camera_locked'] >[0]
	>
	type __shm_hitalama_map_settings_3 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_settings['backup_time'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_settings['map'] >['backup_time'] >[0]
	>
	type __shm_hitalama_map_settings_4 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_settings['slideshow_frame'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_settings['map'] >['slideshow_frame'] >[0]
	>
	type __shm_hitalama_map_settings_5 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_settings['viewport_frames_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_settings['map'] >['viewport_frames_visible'] >[0]
	>
	type $mol_button_minor__title_shm_hitalama_map_settings_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['scale_percent'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_settings_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['reset_scale'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_textarea__value_shm_hitalama_map_settings_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['description'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_settings_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_settings_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['Description_edit'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['editor_mode_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['widget_list_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['widget_props_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['widget_headers_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['viewport_frames_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['arrows_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['slideshow_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_paginator__value_shm_hitalama_map_settings_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['slideshow_frame'] >
		,
		ReturnType< $mol_paginator['value'] >
	>
	type $mol_view__sub_shm_hitalama_map_settings_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_hitalama_map_settings_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_settings_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['camera_locked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_text__text_shm_hitalama_map_settings_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__value_shm_hitalama_map_settings_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['backup_time'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_shm_hitalama_map_settings_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_download__uri_shm_hitalama_map_settings_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['exported_json'] >
		,
		ReturnType< $mol_button_download['uri'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_settings_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['exported_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__title_shm_hitalama_map_settings_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__uri_shm_hitalama_map_settings_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['exported_without_files_json'] >
		,
		ReturnType< $mol_button_download['uri'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_settings_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['exported_without_files_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__title_shm_hitalama_map_settings_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $shm_hitalama_attach__attach_title_shm_hitalama_map_settings_38 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_attach['attach_title'] >
	>
	type $shm_hitalama_attach__attach_new_shm_hitalama_map_settings_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['restore_file'] >
		,
		ReturnType< $shm_hitalama_attach['attach_new'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_settings_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['Favorite_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__title_shm_hitalama_map_settings_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['favorite_title'] >
		,
		ReturnType< $mol_check_icon['title'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_settings_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['map_favorite'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_settings_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_settings_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['history_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_map_settings_45 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_settings['map_cut'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_vector_2d__shm_hitalama_map_settings_46 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	export class $shm_hitalama_map_settings extends $mol_list {
		slideshow_enabled( next?: ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['slideshow_enabled'] > ): ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['slideshow_enabled'] >
		camera_locked( next?: ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['camera_locked'] > ): ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['camera_locked'] >
		backup_time( next?: ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['backup_time'] > ): ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['backup_time'] >
		slideshow_frame( next?: ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['slideshow_frame'] > ): ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['slideshow_frame'] >
		slideshow_frame_str( ): ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['slideshow_frame_str'] >
		viewport_frames_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['viewport_frames_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_settings['map'] >['viewport_frames_visible'] >
		scale_percent( ): string
		reset_scale( next?: any ): any
		Scale( ): $mol_button_minor
		description( next?: string ): string
		Description_edit( ): $mol_textarea
		Description_field( ): $mol_form_field
		editor_mode_enabled( next?: boolean ): boolean
		Editor_mode_enabled( ): $mol_check_box
		widget_list_visible( next?: boolean ): boolean
		Widget_list_visible( ): $mol_check_box
		widget_props_visible( next?: boolean ): boolean
		Widget_props_visible( ): $mol_check_box
		widget_headers_visible( next?: boolean ): boolean
		Widget_headers_visible( ): $mol_check_box
		Viewport_frames_visible( ): $mol_check_box
		arrows_visible( next?: boolean ): boolean
		Arrows_visible( ): $mol_check_box
		Slideshow_enabled( ): $mol_check_box
		Num( ): $mol_paginator
		Slideshow_controls( ): $mol_view
		Camera_locked( ): $mol_check_box
		Backup_label( ): $mol_text
		Backup_time( ): $mol_string
		Backup_controls( ): $mol_view
		exported_json( ): string
		exported_file_name( ): string
		Export( ): $mol_button_download
		exported_without_files_json( ): string
		exported_without_files_file_name( ): string
		Export_without_files( ): $mol_button_download
		restore_file( next?: any ): any
		Restore( ): $shm_hitalama_attach
		Favorite_icon( ): $mol_icon_star
		favorite_title( ): string
		map_favorite( next?: boolean ): boolean
		Favorite( ): $mol_check_icon
		History( ): $mol_button_minor
		map_cut( next?: any ): any
		Cut_map( ): $shm_confirm_delete
		map( ): $shm_hitalama_map
		team( next?: any ): any
		zoom( next?: number ): number
		shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number>
		history_open( next?: any ): any
		rights_visible( next?: boolean ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map